import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FileText, X } from "lucide-react";
import { toast } from "react-toastify";


const RecipeModal = ({
  show,
  onHide,
  themeColors,
  treatmentDetails = [],
  recipeDetails = [],
  AllFilterdata,
  selected = [],
  weight,
  liquorVal,
  calculateRecipeQty,
  onRecipeRowsChange,
}) => {
  const {
    iscolour,
    iscolourDark,
    isdark
  } = themeColors;

  const [recipeRows, setRecipeRows] = useState([]);

  const [selectedRecipeRows, setSelectedRecipeRows] = useState([]);

  const handleRecipeRowSelect = (index, checked) => {
    setSelectedRecipeRows((prev) => {
      if (checked) {
        return [...prev, index];
      }

      return prev.filter((i) => i !== index);
    });
  };

  const ProcessGroup = AllFilterdata?.ProcessGrp;
  const ItemName = AllFilterdata?.Item;
  const SubProcess = AllFilterdata?.RecipeSubProcess;

  useEffect(() => {
    if (!show) return;

    const treatmentRows = Array.isArray(treatmentDetails)
      ? treatmentDetails.map((row) => ({
        ...row,
        DetailType: "Treatment",
        isNew: false,
      }))
      : [];

    const recipeRowsData = Array.isArray(recipeDetails)
      ? recipeDetails.map((row) => ({
        ...row,
        DetailType: "Recipe",
        isNew: false,
      }))
      : [];

    setRecipeRows([...treatmentRows, ...recipeRowsData]);

  }, [show]);


  const addRecipeRow = () => {
    const newRow = {
      TempNHoldTime: "",
      GramsPerMtr: "",
      IsWeightReq: false,
      IsTakaReq: false,
      IsMActive: false,
      IsLIQReq: false,
      Multiplier: 1,
      IssQty: 0,

      ItemProcessGroupID: "",
      ItemId: "",
      RecipeSubProcessId: "",
      SubProcessName: "",

      DetailType: "Recipe",
      isNew: true,
    };

    const updatedRows = [...recipeRows, newRow];

    setRecipeRows(updatedRows);
    onRecipeRowsChange?.(updatedRows);
  };


  // EDIT RECORD
  const updateRecipeRow = (index, field, value) => {
    const updatedRows = recipeRows.map((row, i) => {
      if (i !== index) return row;

      const updatedRow = {
        ...row,
        [field]: value,
      };

      // Calculation LotEntry ke function se hoga
      if (updatedRow.DetailType === "Recipe") {
        updatedRow.IssQty = calculateRecipeQty(
          updatedRow,
          selected,
          weight,
          liquorVal
        );
      }

      return updatedRow;
    });

    setRecipeRows(updatedRows);
    onRecipeRowsChange?.(updatedRows);
  };


// DELETE SELECTED RECORDS
const deleteSelectedRecipeRows = () => {
    if (selectedRecipeRows.length === 0) {
        toast.warning("Please select a recipe detail record");
        return;
    }

    const updatedRows = recipeRows.filter(
        (_, index) => !selectedRecipeRows.includes(index)
    );

    setRecipeRows(updatedRows);
    onRecipeRowsChange?.(updatedRows);
    setSelectedRecipeRows([]);

    toast.success("Selected detail rows removed");
};


  // const updateRecipeRow = (index, field, value) => {

  //   setRecipeRows((prev) => {
  //     const updated = [...prev];

  //     updated[index] = {
  //       ...updated[index],
  //       [field]: value,
  //     };

  //     const updatedRows = [...updated];

  //     // Parent ko updated rows bhejo
  //     onRecipeRowsChange?.(updatedRows);

  //     return updatedRows;
  //   });

  // };


  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      backdrop="static"
      contentClassName="rd-modal-content"
    >
      <style>{`
        .rd-modal-content {
          background: ${isdark === "light" ? iscolour?.Colour1 || "#fff" : iscolourDark?.Colour10 || "#1a1208"} !important;
          border: none !important;
          border-radius: 14px !important;
          overflow: hidden;
          box-shadow: 0 25px 60px rgba(0,0,0,0.35) !important;
        }
        .rd-header {
          background: linear-gradient(135deg,
            ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"} 0%,
            ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour7 || "#7a5637"} 100%
          );
          padding: 14px 20px;
          display: flex; align-items: center; justify-content: space-between;
        }
        .rd-header-icon {
          width: 32px; height: 32px; border-radius: 8px;
          background: rgba(255,255,255,0.2);
          display: flex; align-items: center; justify-content: center;
        }
        .rd-close-btn {
          background: rgba(255,255,255,0.15);
          border: 1px solid rgba(255,255,255,0.3) !important;
          color: #fff; border-radius: 8px;
          width: 32px; height: 32px;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: background 0.2s;
        }
        .rd-close-btn:hover { background: rgba(255,255,255,0.3); }
        .rd-cost-strip {
          background: ${isdark === "light" ? iscolour?.Colour3 || "#faf8f5" : iscolourDark?.Colour9 || "#2d1f0f"};
          padding: 8px 20px; display: flex; justify-content: flex-end; align-items: center;
          border-bottom: 1px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour7 || "#7a5637"};
        }
        .rd-cost-badge {
          background: ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour6 || "#8b5a2b"};
          color: #fff; padding: 4px 16px; border-radius: 20px;
          font-size: 12px; font-weight: 700; letter-spacing: 0.5px;
        }
        .rd-table-wrap {
          overflow-x: auto; overflow-y: auto; max-height: 360px;
        }
        .rd-table-wrap::-webkit-scrollbar { width: 5px; height: 5px; }
        .rd-table-wrap::-webkit-scrollbar-track {
          background: ${isdark === "light" ? iscolour?.Colour3 || "#faf8f5" : iscolourDark?.Colour10 || "#1a1208"};
        }
        .rd-table-wrap::-webkit-scrollbar-thumb {
          background: ${isdark === "light" ? iscolour?.Colour7 || "#d7b08a" : iscolourDark?.Colour6 || "#8b5a2b"};
          border-radius: 4px;
        }
        .rd-tbl { width: 100%; border-collapse: collapse; min-width: 880px; }
        .rd-tbl thead th {
          background: ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour7 || "#7a5637"} !important;
          color: #fff !important;
          font-size: 11px !important; font-weight: 700 !important;
          padding: 9px 10px !important;
          border-right: 1px solid ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"} !important;
          border-bottom: 2px solid ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"} !important;
          white-space: nowrap; text-transform: uppercase; letter-spacing: 0.3px;
          position: sticky; top: 0; z-index: 2;
        }
        .rd-tbl thead th:last-child { border-right: none !important; }
        .rd-tbl tbody td {
          font-size: 12.5px !important; padding: 7px 10px !important;
          border-right: 1px solid ${isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour8 || "#6b4423"} !important;
          border-bottom: 1px solid ${isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour8 || "#6b4423"} !important;
          color: ${isdark === "light" ? iscolour?.Colour11 || "#8b5a2b" : iscolourDark?.Colour1 || "#fcefd9"} !important;
          vertical-align: middle !important; transition: background 0.15s;
        }
        .rd-tbl tbody td:last-child { border-right: none !important; }
        .rd-tbl tbody tr:nth-child(odd) td {
          background: ${isdark === "light" ? iscolour?.Colour4 || "#fef3e8" : iscolourDark?.Colour9 || "#2d1f0f"} !important;
        }
        .rd-tbl tbody tr:nth-child(even) td {
          background: ${isdark === "light" ? iscolour?.Colour1 || "#fff" : iscolourDark?.Colour10 || "#1a1208"} !important;
        }
        .rd-tbl tbody tr:hover td {
          background: ${isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour7 || "#7a5637"} !important;
        }
        .rd-group-pill {
          display: inline-block; padding: 2px 8px; border-radius: 10px;
          font-size: 10.5px; font-weight: 700;
          background: ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour6 || "#8b5a2b"};
          color: #fff; white-space: nowrap;
        }
        .rd-qty-val {
          font-weight: 700 !important; font-size: 13px !important;
          color: ${isdark === "light" ? iscolour?.Colour10 || "#c46f20" : iscolourDark?.Colour2 || "#f5c99f"} !important;
        }

.rd-rchk {
  width: 15px;
  height: 15px;
  accent-color: ${isdark === "light"
          ? iscolour?.Colour8 || "#D78C4D"
          : iscolourDark?.Colour4 || "#e19b5f"};
  cursor: pointer;
}
        .rd-total-wrap { overflow-x: auto; }
        .rd-total-tbl { width: 100%; border-collapse: collapse; min-width: 880px; }
        .rd-total-tbl td {
          background: ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"} !important;
          color: #fff !important; font-weight: 700 !important; font-size: 13px !important;
          padding: 8px 10px !important; border: none !important;
        }
        .rd-footer {
          background: ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"};
          padding: 12px 20px; display: flex; justify-content: space-between; align-items: center;
          border-top: 2px solid ${isdark === "light" ? iscolour?.Colour10 || "#c46f20" : iscolourDark?.Colour7 || "#7a5637"};
        }
        .rd-summary-text {
          font-size: 12px; font-weight: 600; letter-spacing: 0.3px;
          color: ${isdark === "light" ? iscolour?.Colour4 || "#fef3e8" : iscolourDark?.Colour2 || "#f5c99f"};
        }
        .rd-action-btn {
          display: flex; align-items: center; gap: 6px;
          font-size: 13px; font-weight: 700; padding: 7px 20px;
          border-radius: 8px; border: none !important; cursor: pointer;
          transition: all 0.2s ease; letter-spacing: 0.2px;
        }
        .rd-action-btn:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0,0,0,0.25); }
        .rd-btn-delete { background: #dc2626; color: #fff; }
        .rd-btn-ok     { background: #16a34a; color: #fff; }
        .rd-btn-cancel {
          background: rgba(255,255,255,0.15); color: #fff;
          border: 1px solid rgba(255,255,255,0.35) !important;
        }
        .rd-btn-cancel:hover { background: rgba(255,255,255,0.28); }
        .rd-edit-select {
  width: 100%;
  min-width: 100px;
  height: 30px;
  padding: 3px 7px;
  border: 1px solid ${isdark === "light"
          ? iscolour?.Colour6 || "#e6a571"
          : iscolourDark?.Colour7 || "#7a5637"};
  border-radius: 5px;
  outline: none;
  font-size: 12px;
  color: ${isdark === "light"
          ? iscolour?.Colour11 || "#8b5a2b"
          : iscolourDark?.Colour1 || "#fcefd9"};
  background: ${isdark === "light"
          ? iscolour?.Colour1 || "#fff"
          : iscolourDark?.Colour10 || "#1a1208"};
  cursor: pointer;
  box-sizing: border-box;
}

.rd-edit-select:focus {
  border-color: ${isdark === "light"
          ? iscolour?.Colour8 || "#D78C4D"
          : iscolourDark?.Colour6 || "#8b5a2b"};
}

.rd-edit-input {
  width: 100%;
  min-width: 65px;
  height: 30px;
  padding: 4px 7px;
  border: 1px solid ${isdark === "light"
          ? iscolour?.Colour6 || "#e6a571"
          : iscolourDark?.Colour7 || "#7a5637"};
  border-radius: 5px;
  outline: none;
  font-size: 12px;
  color: ${isdark === "light"
          ? iscolour?.Colour11 || "#8b5a2b"
          : iscolourDark?.Colour1 || "#fcefd9"};
  background: ${isdark === "light"
          ? iscolour?.Colour1 || "#fff"
          : iscolourDark?.Colour10 || "#1a1208"};
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .rd-edit-select {
    min-width: 120px;
    height: 29px;
    font-size: 11px;
  }

  .rd-edit-input {
    min-width: 75px;
    height: 29px;
    font-size: 11px;
  }
}

.rd-add-record-wrap {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 8px 10px;
  box-sizing: border-box;
  border-top: 1px solid
    ${isdark === "light"
          ? iscolour?.Colour6 || "#ead7c2"
          : iscolourDark?.Colour7 || "#60452e"};
  background: ${isdark === "light"
          ? iscolour?.Colour3 || "#faf7f2"
          : iscolourDark?.Colour9 || "#24180d"};
}

.rd-add-record-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  height: 30px;
  padding: 0 13px;

  border: 1px solid
    ${isdark === "light"
          ? iscolour?.Colour8 || "#d78c4d"
          : iscolourDark?.Colour6 || "#a87342"};

  border-radius: 6px;

  background: ${isdark === "light"
          ? iscolour?.Colour1 || "#ffffff"
          : iscolourDark?.Colour10 || "#1b1109"};

  color: ${isdark === "light"
          ? iscolour?.Colour11 || "#8b5a2b"
          : iscolourDark?.Colour1 || "#fcefd9"};

  font-size: 11px;
  font-weight: 700;

  cursor: pointer;
  transition: all 0.15s ease;
}

.rd-add-record-btn:hover {
  background: ${isdark === "light"
          ? iscolour?.Colour8 || "#d78c4d"
          : iscolourDark?.Colour6 || "#a87342"};

  color: #fff;
}

.rd-add-icon {
  width: 17px;
  height: 17px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  border-radius: 4px;

  font-size: 15px;
  font-weight: 800;
  line-height: 1;
}

@media (max-width: 768px) {
  .rd-add-record-wrap {
    padding: 7px 8px;
  }

  .rd-add-record-btn {
    height: 29px;
    padding: 0 11px;
    font-size: 10px;
  }
}
      `}</style>

      {/* HEADER */}
      <div className="rd-header">
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div className="rd-header-icon"><FileText size={16} color="#fff" /></div>
          <span style={{ fontSize: "15px", fontWeight: "700", color: "#fff", letterSpacing: "0.4px" }}>
            Consumption Recipe Detail
          </span>
        </div>
        <button className="rd-close-btn" onClick={onHide}>
          <X size={15} />
        </button>
      </div>

      {/* COST STRIP */}
      <div className="rd-cost-strip">
        <span className="rd-cost-badge">COST : 1.145</span>
      </div>

      <div className="rd-add-record-wrap">
        <button
          type="button"
          className="rd-add-record-btn"
          onClick={addRecipeRow}
        >
          <span className="rd-add-icon">+</span>
          <span>Add Record</span>
        </button>
      </div>



      {/* TABLE */}
      <div className="rd-table-wrap"></div>

      {/* TABLE */}
      <div className="rd-table-wrap">
        <table className="rd-tbl">
          <thead>
            <tr>
              <th style={{ width: "50px", textAlign: "center" }}>
                Select
              </th>
              <th style={{ width: "120px" }}>Process Group</th>
              <th style={{ width: "75px" }}>Item Short</th>
              <th style={{ width: "155px" }}>Item</th>
              <th style={{ width: "130px" }}>Item Sub Group</th>
              <th style={{ width: "85px", textAlign: "center" }}>
                Sub Process
              </th>
              <th style={{ width: "115px", textAlign: "center" }}>
                Temp / Hold Time
              </th>
              <th style={{ width: "65px", textAlign: "right" }}>
                GPM
              </th>
              <th style={{ width: "55px", textAlign: "center" }}>
                Weight
              </th>
              <th style={{ width: "50px", textAlign: "center" }}>
                Taka
              </th>
              <th style={{ width: "48px", textAlign: "center" }}>
                Mts
              </th>
              <th style={{ width: "48px", textAlign: "center" }}>
                LIQ
              </th>
              <th style={{ width: "75px", textAlign: "center" }}>
                Multiplier
              </th>
              <th style={{ width: "75px", textAlign: "right" }}>
                Qty.
              </th>
            </tr>
          </thead>

          <tbody>
            {recipeRows.map((row, index) => (

              <tr
                key={
                  row?.TransConsRecipeDtlId ||
                  row?.ProdConsRecipeDtlId ||
                  `recipe-row-${index}`
                }
              >


                <td style={{ textAlign: "center" }}>
                  <input
                    type="checkbox"
                    className="rd-rchk"
                    checked={selectedRecipeRows.includes(index)}
                    onChange={(e) =>
                      handleRecipeRowSelect(index, e.target.checked)
                    }
                  />
                </td>

                {/* Process Group */}
                <td>
                  <select
                    className="rd-edit-select"
                    value={row?.ItemProcessGroupID ?? ""}
                    onChange={(e) =>
                      updateRecipeRow(
                        index,
                        "ItemProcessGroupID",
                        Number(e.target.value)
                      )
                    }
                  >
                    <option value=""> Select Process Group </option>


                    {ProcessGroup.map((item) => (
                      <option key={item.ItemProcessGroupID} value={item.ItemProcessGroupID}>
                        {item.ItemProcessGroupName}
                      </option>
                    ))}

                  </select>
                </td>


                {/* Item Short */}
                <td>
                  <select
                    className="rd-edit-select"
                    value={row?.ItemId ?? ""}
                    onChange={(e) =>
                      updateRecipeRow(
                        index,
                        "ItemId",
                        e.target.value ? Number(e.target.value) : ""
                      )
                    }
                  >
                    <option value="">Select Item Short</option>

                    {ItemName.map((item) => (
                      <option key={item.ItemId} value={item.ItemId}>
                        {item._I_CODE}
                      </option>
                    ))}
                  </select>
                </td>

                {/* Item */}
                <td>
                  <select
                    className="rd-edit-select"
                    value={row?.ItemId ?? ""}
                    onChange={(e) =>
                      updateRecipeRow(
                        index,
                        "ItemId",
                        Number(e.target.value)
                      )
                    }
                  >
                    <option value="">Select Item</option>

                    {ItemName.map((item) => (
                      <option key={item.ItemId} value={item.ItemId}>
                        {item.ItemName}
                      </option>
                    ))}

                  </select>
                </td>

                {/* Item Sub Group */}
                <td>
                  {row?.isNew ? (
                    <input
                      type="text"
                      className="rd-edit-input"
                      value={row?.ItemId ?? ""}
                      onChange={(e) =>
                        updateRecipeRow(
                          index,
                          "ItemName",
                          e.target.value
                        )
                      }
                      placeholder="Item Sub Group"
                    />
                  ) : (
                    ItemName?.find(
                      (item) => Number(item?.ItemId) === Number(row?.ItemId)
                    )?.ItemName ?? ""
                  )}
                </td>

                {/* Sub Process */}
                <td>
                  <select
                    className="rd-edit-select"
                    value={row?.RecipeSubProcessId ?? ""}
                    onChange={(e) =>
                      updateRecipeRow(
                        index,
                        "RecipeSubProcessId",
                        Number(e.target.value)
                      )
                    }
                  >
                    <option value="">Select Sub Process</option>

                    {SubProcess.map((item) => (
                      <option key={item.RecipeSubProcessID} value={item.RecipeSubProcessID}>
                        {item.RecipeSubProcessName}
                      </option>
                    ))}
                  </select>
                </td>

                {/* Temp / Hold Time */}
                <td>
                  <input
                    type="number"
                    className="rd-edit-input"
                    value={row?.TempNHoldTime ?? ""}
                    onChange={(e) =>
                      updateRecipeRow(index, "TempNHoldTime", e.target.value)
                    }
                  />
                </td>

                {/* GPM */}
                <td>
                  <input
                    type="number"
                    step="0.001"
                    className="rd-edit-input"
                    value={row?.GramsPerMtr ?? ""}
                    onChange={(e) =>
                      updateRecipeRow(index, "GramsPerMtr", e.target.value)
                    }
                  />
                </td>

                {/* Weight */}
                <td style={{ textAlign: "center" }}>
                  <input
                    type="checkbox"
                    className="rd-rchk"
                    checked={row?.IsWeightReq === true}
                    onChange={(e) =>
                      updateRecipeRow(
                        index,
                        "IsWeightReq",
                        e.target.checked
                      )
                    }
                  />
                </td>

                {/* Taka */}
                {/* Taka */}
                <td style={{ textAlign: "center" }}>
                  <input
                    type="checkbox"
                    className="rd-rchk"
                    checked={row?.IsTakaReq === true}
                    onChange={(e) => {
                      const checked = e.target.checked;

                      if (checked && row?.IsMActive === true) {
                        toast.warning("Taka and MTS cannot be selected together.");
                        return;
                      }

                      updateRecipeRow(
                        index,
                        "IsTakaReq",
                        checked
                      );
                    }}
                  />
                </td>

                {/* Mts */}
                <td style={{ textAlign: "center" }}>
                  <input
                    type="checkbox"
                    className="rd-rchk"
                    checked={row?.IsMActive === true}
                    onChange={(e) => {
                      const checked = e.target.checked;

                      if (checked && row?.IsTakaReq === true) {
                        toast.warning("MTS and Taka cannot be selected together.");
                        return;
                      }

                      updateRecipeRow(
                        index,
                        "IsMActive",
                        checked
                      );
                    }}
                  />
                </td>

                {/* LIQ */}
                <td style={{ textAlign: "center" }}>
                  <input
                    type="checkbox"
                    className="rd-rchk"
                    checked={row?.IsLIQReq === true}
                    onChange={(e) =>
                      updateRecipeRow(
                        index,
                        "IsLIQReq",
                        e.target.checked
                      )
                    }
                  />
                </td>

                {/* Multiplier */}
                <td>
                  <input
                    type="number"
                    className="rd-edit-input"
                    value={row?.Multiplier ?? ""}
                    onChange={(e) =>
                      updateRecipeRow(index, "Multiplier", e.target.value)
                    }
                  />
                </td>

                {/* Qty */}
                <td >
                  <input
                    type="number"
                    step="0.001"
                    className="rd-edit-input"
                    value={Number(row?.IssQty || 0).toFixed(3)}
                    readOnly
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>



      {/* TOTAL BAR */}
      <div className="rd-total-wrap">
        <table className="rd-total-tbl">
          <tbody>
            <tr>
              <td
                colSpan={12}
                style={{
                  textAlign: "right",
                  paddingRight: "14px",
                  fontSize: "12px",
                  opacity: 0.8
                }}
              >
                Grand Total
              </td>

              <td
                style={{
                  textAlign: "right",
                  width: "75px",
                  paddingRight: "10px",
                  fontSize: "14px"
                }}
              >
                {recipeRows
                  .reduce(
                    (sum, row) => sum + (Number(row?.IssQty) || 0),
                    0
                  )
                  .toFixed(3)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* FOOTER */}
      <div className="rd-footer">
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <button className="rd-action-btn rd-btn-delete"
            onClick={deleteSelectedRecipeRows}>
            <X size={13} /> Delete
          </button>
          <span className="rd-summary-text">
            CHEMICAL : 0.018 &nbsp;|&nbsp; COLOUR (REACTIVE) : 1.128
          </span>
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <button className="rd-action-btn rd-btn-ok"
            onClick={() => { toast.success("Recipe confirmed"); onHide(); }}>
            ✔ OK
          </button>
          <button className="rd-action-btn rd-btn-cancel"
            onClick={onHide}>
            <X size={13} /> Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RecipeModal;
